module.exports = __webpack_public_path__ + "images/create-first-board/card-back/cardBack-de.6efaf0ae850d00ed8ab3.svg";